module.exports = __webpack_public_path__ + "static/img/hos-hk-india-img-my-garage-01.4fea021.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos-hk/hos-hk-india-img-my-garage-01.png
// module id = RBO2
// module chunks = 0